export default __webpack_public_path__ + "static/media/EmptyActivity.891f547b.svg";